import React from "react";
import { useHistory } from "react-router-dom";

import { LegCard } from "ui/components";

const Legs = ({ data, manifestID, status, trucking, type }) => {
  const History = useHistory();

  return (
    <div>
      {data?.map((d, i) => (
        <LegCard
          type={d?.type?.replace("_", " ")}
          onClick={() =>
            status === "started" &&
            History.push(`/leg/${d?.id}`, {
              manifest_id: manifestID,
              is_trucking: trucking,
              manifest_type: type,
            })
          }
          key={i}
          num={i + 1}
          name={d?.location?.name}
          contact={
            d?.location?.name === d?.location?.contact_person
              ? d?.location?.phone_number
              : `${d?.location?.contact_person} - ${d?.location?.phone_number}`
          }
          address={d?.location?.address}
          region={`${d?.location?.region?.village_name}, ${d?.location?.region?.district_name}, ${d?.location?.region?.regency_name}, ${d?.location?.region?.province_name}`}
          status={d?.status}
        />
      ))}
    </div>
  );
};

export default Legs;
